if (!customElements.get('footer-menu-disclosure')) {
  class FooterMenuDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.mobileQuery.addEventListener('change', this.onBreakpointChange);
      this.onBreakpointChange(this.mobileQuery);
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
    }

    onBreakpointChange(event) {
      this.details.open = !event.matches;
    }
  }

  customElements.define('footer-menu-disclosure', FooterMenuDisclosure);
}
